/**
 * Check if a URL path is the products page. This includes the product
 * suppliers page.
 * @param urlPath The URL path to check.
 * @returns The URL path is the products page.
 */
function isProductsPage(urlPath: string) {
    return urlPath.startsWith('/products');
}

/**
 * Check if a URL path is the product suppliers page.
 * @param urlPath The URL path to check.
 * @returns The URL path is the product suppliers page.
 */
export function isProductSuppliersPage(urlPath: string) {
    return isProductsPage(urlPath) && urlPath.includes('/suppliers');
}

/**
 * Convert a products page URL path to a product suppliers page URL path. Does
 * nothing if the URL path is not the products page or is already the product
 * suppliers page.
 * @param urlPath The URL path to convert.
 * @returns The product suppliers page URL path.
 */
export function convertToProductSuppliersUrl(urlPath: string): string {
    if (!isProductsPage(urlPath) || isProductSuppliersPage(urlPath)) {
        return urlPath;
    }
    return urlPath.replace('/products', '/products/suppliers');
}
